const categories = () => {
    
    var carousel = $(".categories-slider")
    
    if(carousel.length > 0) {
        
        /*if ($(window).width() < 992) {
            if (carousel.hasClass('slick-initialized')) {
                carousel.slick('unslick');
            }
            carousel.slick({
                mobileFirst: true,
                arrows: false,
                slidesToShow: 1.5,
                infinite: false
            })
        } else {
            if (carousel.hasClass('slick-initialized')) {
                carousel.slick('unslick');
            }
        }*/   
    }
}

module.exports = {
    categories
};